module.exports = __webpack_public_path__ + "static/egyptian-fitted-sheet-navy-1-6f5a392595d1e6d25c0e82a3ee72a1f1.webp";